var f = fetch;
var h = Headers;

export { f as fetch, h as Headers };
